import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Users } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { initials } from '@/utils/ui';
import { useTranslation } from 'react-i18next';

const DirectoryTab = ({ directory = [] }) => {
  const { t } = useTranslation();

  if (!directory.length) {
    return (
      <Card>
        <CardContent className="py-12 text-center">
          <Users
            className="mx-auto mb-4 text-slate-400"
            size={48}
          />
          <h3 className="text-lg font-semibold mb-2">
            {t('groupSpace.directory.noMembersTitle')}
          </h3>
          <p className="text-slate-600">
            {t('groupSpace.directory.noMembersDescription')}
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
      {directory.map((member) => (
        <Card
          key={member.user.id}
          data-testid={`member-card-${member.user.id}`}
        >
          <CardHeader>
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-500 rounded-full flex items-center justify-center text-white font-bold text-lg">
                {initials(
                  member.user.first_name,
                  member.user.last_name
                )}
              </div>
              <div>
                <CardTitle className="text-lg">
                  {member.user.first_name}{' '}
                  {member.user.last_name}
                </CardTitle>
                <p className="text-sm text-slate-600">
                  {member.user.profession ||
                    t(
                      'groupSpace.directory.memberRoleDefault'
                    )}
                </p>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            {member.user.city && member.user.country && (
              <p className="text-sm text-slate-600">
                {member.user.city}, {member.user.country}
              </p>
            )}
            <Badge variant="outline" className="mt-2">
              {member.role}
            </Badge>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default DirectoryTab;
